if (!customElements.get('funlab-pdp-sticky-atc')) {
  customElements.define(
    'funlab-pdp-sticky-atc',
    class FunlabPdpStickyAtc extends HTMLElement {
      connectedCallback() {
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.button = this.querySelector('[data-funlab-sticky-button]');
        this.price = this.querySelector('[data-funlab-sticky-price]');
        this.productInfo = document.querySelector('main product-info[id^="MainProduct-"]');
        this.hasSeenPrimaryButton = false;

        if (!this.button || !this.productInfo) return;

        this.onStickyClick = this.onStickyClick.bind(this);
        this.onMobileChange = this.onMobileChange.bind(this);
        this.onProductMutation = this.onProductMutation.bind(this);
        this.button.addEventListener('click', this.onStickyClick);
        this.mobileQuery.addEventListener('change', this.onMobileChange);

        this.productObserver = new MutationObserver(this.onProductMutation);
        this.productObserver.observe(this.productInfo, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
        });

        this.bindPrimaryButton();
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onStickyClick);
        this.mobileQuery?.removeEventListener('change', this.onMobileChange);
        this.primaryObserver?.disconnect();
        this.productObserver?.disconnect();
      }

      bindPrimaryButton() {
        const nextButton = this.productInfo.querySelector('.product-form__submit');
        if (!nextButton || nextButton === this.primaryButton) {
          this.syncState();
          return;
        }

        this.primaryObserver?.disconnect();
        this.primaryButton = nextButton;
        this.primaryObserver = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) this.hasSeenPrimaryButton = true;
            this.primaryButtonIsVisible = entry.isIntersecting;
            this.updateVisibility();
          },
          { threshold: 0.05 }
        );
        this.primaryObserver.observe(this.primaryButton);
        this.syncState();
      }

      onProductMutation() {
        if (!this.primaryButton?.isConnected) this.bindPrimaryButton();
        this.syncState();
      }

      onMobileChange() {
        this.updateVisibility();
      }

      onStickyClick() {
        this.bindPrimaryButton();
        if (!this.primaryButton || this.isPrimaryDisabled()) return;
        this.primaryButton.click();
      }

      isPrimaryDisabled() {
        return (
          this.primaryButton?.disabled ||
          this.primaryButton?.getAttribute('aria-disabled') === 'true'
        );
      }

      syncState() {
        if (!this.primaryButton) return;

        const primaryLabel = this.primaryButton.querySelector('span:not(.sold-out-message)');
        const soldOutLabel = this.primaryButton.querySelector('.sold-out-message:not(.hidden)');
        const label = soldOutLabel?.textContent?.trim() || primaryLabel?.textContent?.trim();
        if (label) this.button.textContent = label;

        this.button.disabled = this.isPrimaryDisabled();
        this.button.setAttribute('aria-disabled', String(this.isPrimaryDisabled()));

        if (this.price) {
          const priceContainer = this.productInfo.querySelector('[id^="price-"] .price');
          const priceNode = priceContainer?.classList.contains('price--on-sale')
            ? priceContainer.querySelector('.price-item--sale.price-item--last')
            : priceContainer?.querySelector('.price__regular .price-item--regular');
          if (priceNode?.textContent?.trim()) this.price.textContent = priceNode.textContent.trim();
        }

        this.updateVisibility();
      }

      hasBlockingDialog() {
        return Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]')).some(
          (dialog) => {
            if (this.contains(dialog)) return false;
            const style = window.getComputedStyle(dialog);
            const rect = dialog.getBoundingClientRect();
            const intersectsViewport =
              rect.right > 0 &&
              rect.bottom > 0 &&
              rect.left < window.innerWidth &&
              rect.top < window.innerHeight;
            return (
              style.display !== 'none' &&
              style.visibility !== 'hidden' &&
              style.opacity !== '0' &&
              rect.width > 0 &&
              rect.height > 0 &&
              intersectsViewport
            );
          }
        );
      }

      updateVisibility() {
        const shouldShow =
          this.mobileQuery.matches &&
          this.hasSeenPrimaryButton &&
          !this.primaryButtonIsVisible &&
          !this.hasBlockingDialog();
        this.hidden = !shouldShow;
      }
    }
  );
}
